import moment from 'moment';
import {
  format,
  formatISO,
  formatISO9075,
  formatRFC7231,
  parse,
  parseISO,
  addSeconds,
  intervalToDuration,
  formatDuration,
  isValid,
} from 'date-fns';

export default {
  data() {
    return {
      isMobile: false,
    };
  },

  computed: {
    darkMode() {
      const { darkMode } =
        this.getMe !== undefined && this.getMe?.preferences !== undefined
          ? this.getMe?.preferences
          : {};
      if (darkMode !== undefined) {
        return darkMode;
      }
      return false;
    },

    utility_hasClipboard() {
      return !!navigator.clipboard;
    },
  },

  methods: {
    utility_onResize() {
      if (window.innerWidth < 601) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },

    utility_lastSix(s) {
      if (!s || s === undefined) return '';
      const d = s?.toString();
      return d.substr(d.length - 6);
    },

    utility_firstEight(s) {
      if (!s || s === undefined) return '';
      const d = s?.toString();
      return d.substr(0, 8);
    },

    utility_yesNo(v) {
      if (v === undefined) return;
      if (v) {
        return `Yes`;
      }
      return `No`;
    },

    utility_apexConvert(m) {
      if (m === undefined) return;
      if (m.includes('apex')) {
        return `E6 Golf 2026`;
      }
      return m;
    },

    utility_capitalize(word) {
      if (word === undefined) return;
      if (word && typeof word === 'string') {
        return word?.charAt(0)?.toUpperCase() + word?.slice(1);
      }
    },

    utility_capitalizeWords(words) {
      if (words && typeof words === 'string') {
        const splitWords = words?.split(' ');
        return (
          splitWords
            .map((word) => {
              return word[0]?.toUpperCase() + word?.substring(1);
            })
            ?.join(' ') ?? ''
        );
      }
    },

    utility_percentage(v) {
      if (v || v === 0) return `${(v * 100).toFixed(1)}%`;
      return '-';
    },

    utility_valueCheck(v) {
      if (v === undefined || v === null || v?.toLowerCase() === 'undisclosed') return 'N/A';
      return v;
    },

    utility_formatCurrency(value) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '-';
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },

    utility_centsToDollars(num) {
      if (!num) {
        num = 0;
      }
      const dollars = parseInt(num) / 100;
      return dollars;
    },

    utility_gameModeFormat(mode) {
      if (mode) {
        //* Object format instead of switch. Works but more duplication
        // const modes = {
        //   ClosesttothePin: 'Closest to the Pin',
        //   ClosestToPin: 'Closest to the Pin',
        //   closest_to_pin: 'Closest to the Pin',
        //   LongDrive: 'Long Drive',
        //   LongestDrive: 'Long Drive',
        //   longest_drive: 'Long Drive',
        //   StrokePlay: 'Stroke Play',
        //   stroke_play: 'Stroke Play',
        // };
        // return modes[mode.toLowerCase()] ?? 'Mode not found';

        // return this.event.gameMode.match(/[A-Z]*[a-z]+/g).join(' ') //* works but doesn't match ClosesttothePin
        switch (mode) {
          case 'ClosesttothePin':
          case 'ClosestToPin':
          case 'closest_to_pin':
            return this.$t('gameMode.ktp');
          case 'LongDrive':
          case 'LongestDrive':
          case 'longest_drive':
            return this.$t('gameMode.longDrive');
          case 'LongDriveWorldSeries':
            return this.$t('gameMode.longDriveWS');
          case 'StrokePlay':
          case 'stroke_play':
            return this.$t('gameMode.strokePlay');
          case 'Blackout':
          case 'Solaro':
          case 'Blackout-Solaro':
          case 'Solaro-Blackout':
          case 'minigame_blackout':
          case 'minigame_solaro':
            return this.$t('gameMode.solaroBlackout');
          case 'minigame_blackoutrange':
          case 'minigame_rangeblackout':
            return this.$t('gameMode.solaroBlackoutRange');
          case 'Darts':
          case 'Henyett-Darts':
          case 'minigame_darts':
            return this.$t('gameMode.darts');
          case 'minigame_horse':
          case 'Horse':
            return this.$t('gameMode.horse');
          case 'minigame_tennis':
          case 'Tennis':
            return this.$t('gameMode.tennis');
          case 'minigame_301':
          case '301':
            return this.$t('gameMode.301');
          case 'minigame_highscore':
          case 'HighScore':
            return this.$t('gameMode.highScore');
          case 'minigame_billiards':
          case 'Billiards':
            return this.$t('gameMode.billiards');
          case 'minigame_demolition_driving_range':
            return this.$t('gameMode.e6ddr');
          case 'minigame_ddr':
            return this.$t('gameMode.ddr');
          case 'minigame_shotforshot':
            return this.$t('gameMode.shotForShot');
          case 'minigame_smashhit':
            return this.$t('gameMode.smashHit');
          case 'minigame_longdriverange':
            return this.$t('gameMode.longDriveRange');
          case 'minigame_ldworldseries':
            return this.$t('gameMode.longDriveWS');
          case 'minigame_lasvegas':
            return this.$t('gameMode.lasVegas');
          case 'minigame_icetrolls':
            return this.$t('gameMode.iceTrolls');
          case 'minigame_battlestations':
            return this.$t('gameMode.battleStations');
          case 'minigame_carnival':
            return this.$t('gameMode.carnival');
          case 'chip_n_putt':
            return this.$t('gameMode.chipNPutt');
          case 'practice_driving_range':
          case 'driving_range':
            return this.$t('gameMode.drivingRange');
          case 'practice_chip_n_putt':
            return this.$t('gameMode.chipPutt');
          case 'match_play':
            return this.$t('gameMode.match');
          case 'scramble':
          case 'Scramble':
            return this.$t('gameMode.scramble');
          case 'best_ball':
          case 'BestBall':
            return this.$t('gameMode.bestBall');
          case 'stableford':
            return this.$t('gameMode.stableford');
          case 'stableford_modified':
            return this.$t('gameMode.stablefordMod');
          case 'wsog':
            return this.$t('gameMode.wsog');
          case 'performance_team_stroke':
            return this.$t('gameMode.perfTeam');
          case 'inhouse_tool.ai_testing':
            return this.$t('gameMode.ai');
          default:
            return this.$t('gameMode.default');
        }
      }
      return this.$t('gameMode.default');
    },

    utility_discountPercentage(product, regPrice, discount) {
      if (product && product?.promotion && !discount?.price) {
        return this.$t('store.general.special');
      }

      if (regPrice?.price && discount?.price) {
        const { price: discountPrice } = discount;
        const { price: regularPrice } = regPrice;
        const percentage = (((regularPrice - discountPrice) / regularPrice) * 100).toFixed(0);
        return `${percentage}% ${this.$t('store.general.off')}`;
      }
      return '-';
    },

    utility_formatDateAndTime(date) {
      if (date === undefined || date === null) return;
      const formattedDate = date.replace('Etc/GMT', '');
      return `${moment(formattedDate).format('L LT')}`; //* 01/22/2019 4:00 PM
    },

    utility_formatDateAndTimeUTC(date) {
      if (date === undefined || date === null) return;
      const formattedDate = date.replace('Etc/GMT', '');
      return `${moment.utc(formattedDate).format('L LT')}`; // 01/22/2019 4:00 PM
    },

    utility_formatDateAndTimeDB(date) {
      if (date === undefined || date === null) return;
      const dateFormat = formatISO9075(parseISO(date), { representation: 'date' });
      const dbDateFormat = formatRFC7231(parseISO(date));
      const splitGMTTime = dbDateFormat.split(/(\d+:\d+:\d+\sGMT)/)[1];
      return `${dateFormat} ${splitGMTTime}`; // 2021-08-24 22:45:31 GMT
    },

    utility_formatDateAndTimeOpen(date) {
      if (date === undefined || date === null) return 'Open';
      return `${moment(date).format('L LT')}`; // 01/22/2019 4:00 PM
    },

    utility_formatDateMonthAndYear(date) {
      if (date === undefined || date === null) return 'Open';
      return `${moment(date).format('L')}`; // 01/18/2022
    },

    utility_formatDateMY(date) {
      if (date === undefined || date === null) return;
      // return `${format(parseISO(date), 'P')}`; // 01/18/2022
      return `${format(parseISO(date), 'PP')}`; // Jan 22, 2022
    },

    utility_formatTimeToMonthAndYear(time) {
      if (time === undefined || time === 'N/A') return 'N/A';
      if (time === 'Just Now') return time;
      return moment.utc(String(time), 'YYYY-MM-DDTHH:mm:ssZ').format('MMM D, YYYY'); // Oct 29, 2018
    },

    utility_formatDateFriendly(date) {
      if (date === undefined || date === 'N/A') return 'N/A';
      return format(parseISO(date), 'PPP'); // October 29, 2022
      // return moment(date).format('MMM D, YYYY'); // Oct 29, 2018
    },

    utility_formatDateAlt(date) {
      if (date === undefined || date === 'N/A') return 'N/A';
      return format(parseISO(date), 'M.dd.yy'); // 1.31.24
    },

    utility_formatDate(date) {
      if (date === undefined || date === '') return '-';
      return moment(date).format('MM/DD/YYYY'); // 01/22/2019
    },

    utility_formatDateSlashes(date) {
      if (date === undefined || date === '') return '-';
      return `${format(parseISO(date), 'P')}`; // 01/22/2019
    },

    utility_formatTime(time) {
      if (time === undefined) return;
      return moment(time).format('LT');
    },

    utility_formatTimeFNS(time) {
      if (time === undefined) return;
      return format(parseISO(time), 'hh:mmaaa');
    },

    utility_fromDate(d) {
      if (d === '' || d === undefined) return;
      if (moment(d).isBefore()) {
        return `Expired: ${moment(d).format('L LT')}`;
      }
      return `Expires: ${moment(d).format('L LT')}`;
    },

    utility_clubTypeKeyToFriendly(key) {
      if (key === undefined) return key;
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => {
          return str.toUpperCase();
        })
        .trim();
    },

    utility_trackingSystemFormat(ts) {
      switch (ts) {
        case 'ernest_sports_es16':
          return 'ES16 Tour';
        case 'trusimapi_fullswing':
          return 'Full Swing Golf';
        case 'fullswing_kit':
          return 'Full Swing Kit';
        case 'full_swing_golf':
          return 'Full Swing Golf (NATIVE INTEGRATION - DO NOT USE)';
        case 'flight_scope':
          return 'FlightScope';
        case 'trusimapi_gts':
          return 'GTS';
        case 'gpro':
          return 'GPro';
        case 'in_development':
          return 'In Development';
        case 'trusimapi_protee':
          return 'ProTee United';
        case 'trusimapi_sportscoach':
          return 'Sports Coach';
        case 'trusimapi_prosim':
          return 'ProSim';
        case 'trusimapi_smartgolf':
          return 'Smart Golf';
        case 'trusimapi_gpro':
          return 'GPRO Xswing-G';
        case 'trusimapi_powerswing':
          return 'Power Swing';
        case 'trusimapi_foresight':
          return 'Foresight';
        case 'trusimapi_holidaygolf':
          return 'Holiday Golf';
        case 'trusimapi_trugolfmini':
          return 'TruGolf Mini TruSimAPI';
        case 'trusimapi_gsagolf':
          return 'GSA Golf';
        case 'trusimapi_premierdivotaction':
          return 'DivotAction Simulator';
        case 'trusimapi_golfin':
          return 'Golf In';
        case 'golfin':
          return 'GolfIn';
        case 'trusimapi_accugolf':
          return 'AccuGolf';
        case 'garmin':
          return 'Garmin Approach R10 Mobile';
        case 'trusimapi_garmin':
          return 'Garmin Approach R10 PC';
        case 'swing_gauge':
          return 'Swing Gauge';
        case 'skytrak':
          return 'SkyTrak';
        case 'skytrak_jp':
          return 'GPRO SkyTrak';
        case 'trusimapi_developer':
          return 'TruSimAPI Developer';
        case 'trusimapi_greenjoy':
          return 'Greenjoy';
        case 'trugolf_trutrack':
          return 'TruTrack';
        case 'trugolf_truflight_2':
          return 'TruFlight 2';
        case 'trugolf_truflight':
          return 'TruFlight';
        case 'trugolf_mini':
          return 'TruGolf Mini';
        case 'trugolf_apogee':
          return 'Apogee';
        case 'trackman_4':
          return 'Trackman 4';
        case 'trackman_3e':
          return 'Trackman 3e';
        case 'trackman_range':
          return 'TrackMan Range';
        case 'tittle_x':
          return 'Tittle X';
        case 'trusimapi_uneekor':
          return 'Uneekor';
        case 'trusimapi_wizgolf':
          return 'WizGolf';
        case 'trusimapi_wrg':
          return 'WindRider Golf';
        case 'trusimapi_kgolf':
        case 'kgolf':
          return 'KGolf';
        case 'icx':
          return 'ICX';
        case 'phigolf':
          return 'PhiGolf';
        default:
          return ts;
      }
    },

    utility_puttingModeFormat(mode) {
      switch (mode) {
        case 'computerDecides':
          return 'Computer Decides';
        case 'playerPuttsOut':
          return 'Player Putts Out';
        case 'autoScoring':
          return 'Auto Scoring';
        case 'playerDecides':
          return 'Player Decides';
        case '2FootGimme':
          return '2FootGimme';
        case '5FootGimme':
          return '5FootGimme';
        case '10FootGimme':
          return '10FootGimme';
        case '15FootGimme':
          return '15FootGimme';
        case '20FootGimme':
          return '20FootGimme';
        default:
          break;
      }
    },

    utility_terrainTypeFormat(type) {
      switch (type) {
        case 'kTerrainFairway':
          return 'Fairway';
        case 'kTerrainRough':
          return 'Rough';
        case 'kTerrainDeepGrass':
          return 'Deep Grass';
        case 'kTerrainGreen':
          return 'Green';
        case 'kTerrainBunker':
          return 'Bunker';
        case 'kTerrainWater':
          return 'Water';
        case 'kTerrainPavement':
          return 'Pavement';
        case 'kTerrainFringe':
          return 'Fringe';
        case 'kTerrainGravel':
          return 'Gravel';
        case 'kTerrainEarth':
          return 'Earth';
        case 'kTerrainHardAngular':
          return 'Rock';
        case 'kTerrainWood':
          return 'Wood';
        case 'kTerrainAstroTurf':
          return 'AstroTurf';
        case 'kObjectHard':
          return 'Hard Object';
        case 'kOutOfBounds':
          return 'Out of Bounds';
        case 'kRedStakeHazard':
          return 'Red Stake Hazard';
        case 'kYellowStakeHazard':
          return 'Yellow Stake Hazard';
        case 'kFreeDropHazard':
          return 'Free Drop Hazard';
        default:
          return 'Unknown';
      }
    },

    // Alternate conversion =======
    // convertFeetInches(val) {
    //   const scoreFilterValue = this.$options.filters.scoreCheck(val);

    //   if (val === -1 || val === 999999 || val === null || val === undefined) {
    //     return scoreFilterValue;
    //   }
    //   const feet = Math.floor(val);
    //   const inches = Math.round((val - feet) * 12);

    //   //* Metric Conversion
    //   if (this.unitType === this.$t('roundDetails.metric')) {
    //     //* feet/in to meters = divide val by 3.281
    //     return (val / 3.281).toFixed(2);
    //   }
    //   return `${feet}' ${inches}"`;
    // },

    utility_convertFeetInches(val, elevationFlip = false, unitType = 'imperial') {
      // const scoreFilterValue = this.$options.filters.utility_scoreCheck(val);
      const scoreFilterValue = this.utility_scoreCheck(val);

      if (val === -1 || val === 999999 || val === null || val === undefined) {
        return scoreFilterValue;
      }
      const feet = parseInt(val).toFixed(0);
      const inches = Math.abs((val - feet).toFixed(1)) * 10;
      if (elevationFlip) {
        return `${feet * -1}ft ${inches > 0 ? `${inches}in` : ''}`;
      }

      //* Metric Conversion
      if (unitType?.toLowerCase() === 'metric') {
        //* feet/in to meters = divide val by 3.281
        return (val / 3.281).toFixed(2);
      }
      return `${feet}' ${inches}"`;
    },

    // Alternate conversion =======
    // roundNumYards(num) {
    //   const scoreFilterValue = this.$options.filters.scoreCheck(num);

    //   if (num === -1 || num === 999999 || num === null || num === undefined) {
    //     return scoreFilterValue;
    //   }

    //   //* Metric Conversion
    //   if (this.unitType === this.$t('roundDetails.metric')) {
    //     //* feet to meters = divide val by 3.281
    //     return (num / 3.281).toFixed(1);
    //   }
    //   return (num / 3).toFixed(1);
    // },

    utility_roundNumYards(num, unitType = 'imperial') {
      // const scoreFilterValue = this.$options.filters.utility_scoreCheck(num);
      const scoreFilterValue = this.utility_scoreCheck(num);

      if (num === -1 || num === 999999 || num === null || num === undefined) {
        return scoreFilterValue;
      }

      //* Metric Conversion
      if (unitType?.toLowerCase() === 'metric') {
        //* feet/in to meters = divide val by 3.281
        return (num / 3.281).toFixed(2);
      }
      return (num / 3).toFixed(2);
    },

    utility_roundNum(num) {
      if (!num) {
        return 0;
      }
      return Math.abs(Math.round(num));
    },

    utility_isObject(obj) {
      if (!obj || typeof obj === 'string' || obj === null || typeof obj === 'function') {
        return false;
      }
      return Object.keys(obj).length > 0;
    },

    utility_generalTranslate(v) {
      if (v === null || v === undefined) return 'N/A';
      return this.$t(`general.${v}`);
    },

    utility_copyText(text) {
      if (navigator?.clipboard) {
        navigator?.clipboard?.writeText(text).then(
          () => {
            console.log('Copying to clipboard was successful!');
          },
          (err) => {
            console.error('Could not copy text: ', err);
          }
        );
      } else {
        alert('Cannot copy to clipboard');
      }
    },

    // utility_getTimeDuration(time) {
    //   const secondsData = this.utility_convertHMS(time);
    //   const { years, months, days, hours, minutes, seconds } = intervalToDuration({
    //     start: 0,
    //     end: secondsData * 1000,
    //   });

    //   const formatted = formatDuration({
    //     years,
    //     months,
    //     days,
    //     hours,
    //     minutes,
    //     seconds,
    //   });
    //   // console.log('formatted:', formatted);
    //   // const formatted = `${months}:${days}:${hours}:${minutes}:${seconds}`;

    //   return time;
    // },

    utility_getTotalTimeDuration(timeInSecondsArr = []) {
      const accSeconds = timeInSecondsArr.reduce((acc, cur) => {
        return acc + cur;
      }, 0);
      const roundedSeconds = Math.round(accSeconds);
      const { years, months, days, hours, minutes, seconds } = intervalToDuration({
        start: 0,
        end: roundedSeconds * 1000,
      });

      const formatted = formatDuration({
        years,
        months,
        days,
        hours,
        minutes,
        seconds,
      });

      return formatted;
    },

    utility_convertHMS(timeString) {
      const arr = timeString.split(':');
      const seconds = arr[0] * 3600 + arr[1] * 60 + +arr[2];
      return seconds;
    },

    utility_handicapFormat(h) {
      if (h === undefined || h === null) return;
      if (h === '-') return h;
      const hSplit = h.toString().split('-');
      if (hSplit.length > 1) {
        return `+${hSplit[1]}`;
      }
      return hSplit[0];
    },

    utility_toFixedTwoDecimal(v) {
      if (!v || v === null || v === undefined) return '';
      if (v.toString().length > 2) {
        return v.toFixed(2);
      }
      return v;
    },

    // utility_toFixedOneDecimal(v) {
    //   if (v === 0) return 0;
    //   if (!v || v === null || v === undefined) return '';
    //   if (v.toString().length > 2) {
    //     return v.toFixed(1);
    //   }
    //   return v;
    // },

    utility_toFixedOneDecimal(v) {
      if (v === null || v === undefined) return;
      if (v === 'N/A') return v;
      if (v === 0 || v === 0.0 || v === '0' || v === '0.0') return 0;
      const data = v.toString();
      if (data.length > 2) {
        if (data.split('+').length > 1) {
          return Number(data.split('+')?.[1]).toFixed(1);
        }
        return Number(data).toFixed(1);
      }
      return v;
    },

    utility_scoreCheck(s) {
      if (s === null || s === undefined) {
        return 'DNF';
      }
      if (s === -1 || s === 999999) {
        return 'DNQ';
      }
      return s;
    },

    utility_formatHHmmss(time) {
      if (time === undefined) return '-';
      const arr = time.split(':');
      arr[2] = Math.round(arr[2]).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
      });
      return arr.join(':');
    },

    utility_genderFormat(val) {
      switch (val) {
        case 'male':
          return 'M';
        case 'female':
          return 'F';
        default:
          return 'U';
      }
    },

    utility_dexterityFormat(val) {
      switch (val) {
        case 'right':
          return 'R';
        case 'left':
          return 'L';
        default:
          return 'U';
      }
    },

    utility_handicapPresence(val) {
      if (val || val === 0) return Number(val);
      return '-';
    },

    utility_presence(val) {
      const newVal = val?.toString();
      if (newVal && newVal !== 'undisclosed') return val;
      return '-';
    },

    // utility function to return UTC date and time
    utility_MformatDateAndTimeUTC(date) {
      if (date === undefined || date === null) return;

      try {
        let dateObj;

        if (typeof date === 'string') {
          if (date.includes('/')) {
            dateObj = parse(date, 'MM/dd/yyyy', new Date());
          } else {
            dateObj = parseISO(date);
          }
        } else {
          dateObj = date;
        }

        // Validate the parsed date
        if (!isValid(dateObj)) {
          console.error('Invalid date:', dateObj);
          return;
        }

        // Construct a new Date object as if it were in UTC
        const utcDate = new Date(
          Date.UTC(
            dateObj.getUTCFullYear(),
            dateObj.getUTCMonth(),
            dateObj.getUTCDate(),
            dateObj.getUTCHours(), // Keep original UTC hours
            dateObj.getUTCMinutes(),
            dateObj.getUTCSeconds()
          )
        );

        // Format in UTC
        const formatted = format(utcDate, 'MM/dd/yyyy h:mm aa');

        return formatted;
      } catch (e) {
        console.error('e:', e);
        return 'N/A';
      }
    },
  },

  filters: {
    // has func
    utility_capitalize: (word) => {
      if (word === undefined) return;
      if (word && typeof word === 'string') {
        return word?.charAt(0)?.toUpperCase() + word?.slice(1);
      }
    },

    // has func
    utility_formatDateAndTime: (date) => {
      if (date === undefined || date === null) return;
      const formattedDate = date.replace('Etc/GMT', '');
      return `${moment(formattedDate).format('L LT')}`; // 01/22/2019 4:00 PM
    },

    // has func
    utility_formatDateAndTimeUTC: (date) => {
      if (date === undefined || date === null) return;
      const formattedDate = date.replace('Etc/GMT', '');
      return `${moment.utc(formattedDate).format('L LT')}`; // 01/22/2019 4:00 PM
    },

    // has func
    utility_formatDateAndTimeDB: (date) => {
      if (date === undefined || date === null) return;
      const dateFormat = formatISO9075(parseISO(date), { representation: 'date' });
      const dbDateFormat = formatRFC7231(parseISO(date));
      const splitGMTTime = dbDateFormat.split(/(\d+:\d+:\d+\sGMT)/)[1];
      return `${dateFormat} ${splitGMTTime}`; // 2021-08-24 22:45:31 GMT
    },

    // has func
    utility_formatDateAndTimeOpen: (date) => {
      if (date === undefined || date === null) return 'Open';
      return `${moment(date).format('L LT')}`; // 01/22/2019 4:00 PM
    },

    // has func
    utility_formatDateMonthAndYear: (date) => {
      if (date === undefined || date === null) return 'Open';
      return `${moment(date).format('L')}`; // 01/18/2022
    },

    // has func
    utility_formatDateMY: (date) => {
      if (date === undefined || date === null) return;
      // return `${format(parseISO(date), 'P')}`; // 01/18/2022
      return `${format(parseISO(date), 'PP')}`; // Jan 22, 2022
    },

    // has func
    utility_formatTimeToMonthAndYear(time) {
      if (time === undefined || time === 'N/A') return 'N/A';
      if (time === 'Just Now') return time;
      return moment.utc(String(time), 'YYYY-MM-DDTHH:mm:ssZ').format('MMM D, YYYY'); // Oct 29, 2018
    },

    // has func
    utility_formatDateFriendly(date) {
      if (date === undefined || date === 'N/A') return 'N/A';
      return format(parseISO(date), 'PPP'); // October 29, 2022
      // return moment(date).format('MMM D, YYYY'); // Oct 29, 2018
    },

    // has func
    utility_formatDate: (date) => {
      if (date === undefined || date === '') return '-';
      return moment(date).format('MM/DD/YYYY'); // 01/22/2019
    },

    // has func
    utility_formatTime: (time) => {
      if (time === undefined) return;
      return moment(time).format('LT');
    },

    // has func
    utility_fromDate: (d) => {
      if (d === '' || d === undefined) return;
      if (moment(d).isBefore()) {
        return `Expired: ${moment(d).format('L LT')}`;
      }
      return `Expires: ${moment(d).format('L LT')}`;
    },

    // has func
    utility_presence(val) {
      const newVal = val?.toString();
      if (newVal && newVal !== 'undisclosed') return val;
      return '-';
    },

    // has func
    utility_handicapPresence(val) {
      if (val || val === 0) return val;
      return '-';
    },

    // has func
    utility_handicapFormat: (h) => {
      if (h === undefined || h === null) return;
      if (h === '-') return h;
      const hSplit = h.toString().split('-');
      if (hSplit.length > 1) {
        return `+${hSplit[1]}`;
      }
      return hSplit[0];
    },

    // has func
    utility_percentage(v) {
      if (v || v === 0) return `${(v * 100).toFixed(1)}%`;
      return '-';
    },

    // has func
    utility_valueCheck(v) {
      if (v === undefined || v === null || v?.toLowerCase() === 'undisclosed') return 'N/A';
      return v;
    },

    // has func
    utility_formatCurrency(value) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '-';
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },

    // has func
    utility_lastSix: (s) => {
      if (!s || s === undefined) return '';
      const d = s?.toString();
      return d.substr(d.length - 6);
    },

    // has func
    utility_firstEight: (s) => {
      if (!s || s === undefined) return '';
      const d = s?.toString();
      return d.substr(0, 8);
    },

    // has func
    utility_yesNo: (v) => {
      if (v === undefined) return;
      if (v) {
        return `Yes`;
      }
      return `No`;
    },

    // has func
    utility_toFixedTwoDecimal: (v) => {
      if (v === null || v === undefined) return;
      if (v.toString().length > 2) {
        return v.toFixed(2);
      }
      return v;
    },

    // has func
    utility_toFixedOneDecimal: (v) => {
      if (v === null || v === undefined) return;
      if (v === 'N/A') return v;
      if (v === 0 || v === 0.0 || v === '0' || v === '0.0') return 0;
      const data = v.toString();
      if (data.length > 2) {
        if (data.split('+').length > 1) {
          return Number(data.split('+')?.[1]).toFixed(1);
        }
        return Number(data).toFixed(1);
      }
      return v;
    },

    // has func
    utility_scoreCheck: (s) => {
      if (s === null || s === undefined) {
        return 'DNF';
      }
      if (s === -1 || s === 999999) {
        return 'DNQ';
      }
      return s;
    },

    // has func
    utility_formatHHmmss: (time) => {
      if (time === undefined) return '-';
      const arr = time.split(':');
      arr[2] = Math.round(arr[2]).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
      });
      return arr.join(':');
    },
  },
};
